import { render, staticRenderFns } from "./AdminSettingForm.vue?vue&type=template&id=3481ca8d&"
import script from "./AdminSettingForm.vue?vue&type=script&lang=js&"
export * from "./AdminSettingForm.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettingForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports